package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.image.AsyncUrlImage
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.modifier.haze.HazeState
import com.essntl.uikit.modifier.haze.haze
import com.essntl.uikit.modifier.haze.hazeChild
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ServiceItem(
    service: ServiceModel,
    categoryIconUrl: String?,
    onClick: () -> Unit,
    isSelected: Boolean = false,
    modifier: Modifier = Modifier,
) {
    val hazeState = remember { HazeState() }

    Box(
        modifier = modifier
            .width(200.dp)
            .height(160.dp)
            .border(
                width = 2.dp,
                color = if (isSelected) MaterialTheme.esColorScheme.borderAccent else Color.Transparent,
                shape = RoundedCornerShape(20.dp),
            )
            .clip(RoundedCornerShape(20.dp))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .clickable {
                onClick()
            },
    ) {
        AsyncUrlImage(
            url = service.primaryImage?.url ?: "",
            placeholder = {
                AsyncUrlIcon(
                    url = categoryIconUrl ?: "",
                    placeholder = {
                        EsSpinner()
                    },
                    contentDescription = null,
                    tint = Color(0xFF8985A2),
                    modifier = Modifier
                        .fillMaxSize(.4f),
                )
            },
            contentDescription = null,
            modifier = Modifier
                .fillMaxSize()
                .haze(
                    state = hazeState,
                    backgroundColor = Color(0xFF646464),
                    tint = Color(0x4D646464),
                    blurRadius = 30.dp,
                ),
            contentScale = ContentScale.Crop,
        )

        // TODO: add back after MVP if need more interactions on service card
//        Box(
//            contentAlignment = Alignment.Center,
//            modifier = Modifier
//                .align(Alignment.TopEnd)
//                .padding(12.dp)
//                .size(40.dp)
//                .clip(CircleShape)
//                .background(Color.Black.copy(.3f))
//                .clickable {},
//        ) {
//            EsMediumIcon(
//                res = EsIcons.MoreVertical,
//                tint = MaterialTheme.esColorScheme.iconContrast,
//            )
//        }

        Box(
            modifier = Modifier
                .align(Alignment.BottomStart)
                .fillMaxWidth()
                .hazeChild(
                    key = "box",
                    state = hazeState,
                    shape = RoundedCornerShape(10.dp),
                ),
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(all = 1.5f.spacing),
            ) {
                Text(
                    text = service.title.replaceFirstChar { it.uppercaseChar() },
                    color = MaterialTheme.esColorScheme.textContrast,
                    style = MaterialTheme.esTypography.p2Regular14,
                    modifier = Modifier,
                )
            }
        }
    }
}